module.exports = __webpack_public_path__ + "img/6.7d242e0c.jpg";